import { render, staticRenderFns } from "./OrderFood.vue?vue&type=template&id=b4729d90&scoped=true&"
import script from "./OrderFood.vue?vue&type=script&lang=js&"
export * from "./OrderFood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4729d90",
  null
  
)

export default component.exports